import styled from 'styled-components';

export const StickyWrapper = styled.div`
  position: sticky;
  top: ${props => props.theme.Grid.GutterSize};
`